const SELL = "sell";
const BUY = "buy";

export const Intention = {
    getIntention(intention) {
        if (intention === 0) {
            return BUY;
        }

        return SELL;
    },
    fromIntentionString(intentionStr) {
        if (intentionStr.toLowerCase() === BUY) {
            return 0;
        } else if (intentionStr.toLowerCase() === SELL) {
            return 1;
        }

        return null;
    },
    buy() {
        return BUY;
    },
    sell() {
        return SELL;
    }
};